!(function () {
  "use strict";

  if (customElements.get("recipient-form")) return;

  class RecipientForm extends HTMLElement {
    constructor() {
      super();

      this.DEBUG = false;

      this.lang = this.dataset.lang || "en";
      this.fieldCheckbox = this.querySelector('input[type="checkbox"]');
      this.highlightElement(this.fieldCheckbox, "fieldCheckbox");

      this.fieldEmail = this.querySelector(
        'input[name="properties[Recipient email]"]'
      );
      this.highlightElement(this.fieldEmail, "fieldEmail");

      this.fieldName = this.querySelector(
        'input[name="properties[Recipient name]"]'
      );
      this.highlightElement(this.fieldName, "fieldName");

      this.fieldMessage = this.querySelector(
        'textarea[name="properties[Message]"]'
      );
      this.highlightElement(this.fieldMessage, "fieldMessage");

      this.fieldDate = this.querySelector('input[name="properties[Send on]"]');
      this.highlightElement(this.fieldDate, "fieldDate");

      this.fields = [
        this.fieldEmail,
        this.fieldName,
        this.fieldMessage,
        this.fieldDate,
      ];
      this.form = this.closest("form");
      this.highlightElement(this.form, "form");

      this.onChangeEvent = (e) => this.onChange(e);
      this.onSubmitEvent = (e) => this.onSubmit(e);
      this.errors = {
        it: {
          date: "La data non è valida",
          date_min: "La data non può essere precedente ad oggi",
          date_max: "La data non può essere successiva a {{ date }}",
          email: "Inserire una mail valida",
        },
        en: {
          date: "The date is not valid",
          date_min: "The date cannot be earlier than today",
          date_max: "The date cannot be later than {{ date }}",
          email: "Please enter a valid email",
        },
        ja: {
          date: "日付が無効です",
          date_min: "日付は今日より前にすることはできません",
          date_max: "日付は次より後にすることはできません {{ date }}",
          email: "有効なメールアドレスを入力してください",
        },
      };
    }

    connectedCallback() {
      if (!this.fieldCheckbox) return;
      if (!this.form) return;

      this.form.addEventListener("submit", this.onSubmitEvent, true);

      if (this.fieldDate) {
        if ("" == this.fieldDate.value) this.fieldDate.style.color = "#999";

        this.fieldDate.addEventListener("input", (e) => {
          if ("" == this.fieldDate.value) this.fieldDate.style.color = "#999";
          else this.fieldDate.style.color = "#000";
        });
      }

      this.fieldCheckbox.addEventListener("change", this.onChangeEvent);

      this.form.addEventListener("theme:product:add", () => {
        this.fieldCheckbox.checked = !1;
        this.fieldCheckbox.dispatchEvent(new Event("change"));
      });
    }

    clearInputValues() {
      if (!this.fields.length) return;
      for (const e of this.fields) e.value = "";
    }

    onChange(e) {
      this.fieldEmail.required = Boolean(e.target.checked);
      e.target.checked || this.clearInputValues();
    }

    onSubmit(e) {
      if (!this.fieldCheckbox?.checked) return;

      let hasInvalidFields = false;

      if (this.fieldEmail) {
        this.fieldEmail.setCustomValidity("");
        if (!this.fieldEmail.checkValidity()) {
          hasInvalidFields = true;
          this.fieldEmail.setCustomValidity(this.errors[this.lang].email);
          this.fieldEmail.reportValidity();
        }
      }

      if (this.fieldDate) {
        this.fieldDate.setCustomValidity("");
        if (!this.fieldDate.checkValidity()) {
          hasInvalidFields = true;

          const dateValue = new Date(this.fieldDate.value);
          dateValue.setHours(0);
          dateValue.setMinutes(0);

          const dateMin = new Date(this.fieldDate.min);
          dateMin.setHours(0);
          dateMin.setMinutes(0);

          const dateMax = new Date(this.fieldDate.max);
          dateMax.setHours(0);
          dateMax.setMinutes(0);

          this.log({ dateValue, dateMin, dateMax });

          this.fieldDate.setCustomValidity(this.errors[this.lang].date);
          if (dateMin >= dateValue)
            this.fieldDate.setCustomValidity(this.errors[this.lang].date_min);
          if (dateMax < dateValue)
            this.fieldDate.setCustomValidity(
              this.errors[this.lang].date_max.replace(
                "{{ date }}",
                dateMax.toLocaleDateString()
              )
            );

          this.fieldDate.reportValidity();
        }
      }

      if (!hasInvalidFields) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
      if (this.form)
        this.form.removeEventListener("submit", this.onSubmitEvent, true);
    }

    error(message) {
      this.log(message, "error");
    }

    log(message, type = "info") {
      if (!this.DEBUG) return;

      const styles = {
        info: "color: #2196F3",
        error: "color: #f44336",
        success: "color: #4CAF50",
      };

      console.log(`%c[RecipientForm]`, styles[type] || styles.info, message);
    }

    pickRandomColor() {
      const hue = Math.floor(Math.random() * 360);
      return `hsl(${hue}, 70%, 60%)`;
    }

    highlightElement(el, label) {
      if (!this.DEBUG) return;

      const color = this.pickRandomColor();
      el.style.outline = `var(--offset-width) solid var(--debug-color)`;
      el.style.outlineOffset = "calc(0.5 * var(--offset-width))";
      el.style.setProperty("--offset-width", "6px");
      el.style.setProperty("--debug-color", color);
      el.style.setProperty("--debug-label", `"${label}"`);
      el.classList.add("debug-highlighted");

      if (label) {
        const labelEl = document.createElement("div");
        labelEl.className = "debug-label";
        labelEl.textContent = label;
        labelEl.style.cssText = `
          position: absolute;
          background: ${color};
          color: white;
          padding: 2px 6px;
          font-size: 11px;
          font-family: monospace;
          font-weight: bold;
          border-radius: 3px;
          // z-index: 10000;
          pointer-events: none;
          white-space: nowrap;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        `;

        const rect = el.getBoundingClientRect();
        labelEl.style.top = `${rect.top + window.scrollY - 20}px`;
        labelEl.style.left = `${rect.left + window.scrollX}px`;

        if ("static" === getComputedStyle(el).position)
          el.style.position = "relative";

        document.body.appendChild(labelEl);

        el.dataset.debugLabelId = label;
      }

      this.log(`Highlighted “${label}”'`);
    }
  }
  customElements.define("recipient-form", RecipientForm);
})();
